"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Accessibility = function Accessibility(_ref) {
  var _options$style, _options$style2;
  var Options = _ref.Options;
  var initOptions = {
    labels: {
      resetTitle: "Reset",
      closeTitle: "Close",
      menuTitle: "Accessibility Menu",
      increaseText: "Increase Text Size",
      decreaseText: "Decrease Text Size",
      increaseLineHeight: "Increase Line Height",
      decreaseLineHeight: "Decrease Line Height",
      increaseTextSpacing: "Increase Text Spacing",
      decreaseTextSpacing: "Decrease Text Spacing",
      invertColors: "Invert Colors",
      grayHues: "Gray Hues",
      underlineLinks: "Underline Links",
      bigCursor: "Big Cursor",
      readingGuide: "Reading Guide",
      disableAnimations: "Disable Animations",
      readableFont: "Readable Font"
    },
    modules: {
      increaseText: true,
      decreaseText: true,
      increaseLineHeight: true,
      decreaseLineHeight: true,
      increaseTextSpacing: true,
      decreaseTextSpacing: true,
      invertColors: true,
      grayHues: true,
      underlineLinks: true,
      bigCursor: true,
      readingGuide: true,
      disableAnimations: true,
      readableFont: true
    },
    style: {
      mode: "light",
      icon: "access",
      shape: "circle",
      position: {
        bottom: {
          size: 50
        },
        left: {
          size: 20
        },
        toRight: true
      }
    }
  };
  var _useState = (0, _react.useState)(Options || initOptions),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuVisible = _useState4[0],
    setMenuVisible = _useState4[1];
  var _useState5 = (0, _react.useState)(parseInt(localStorage.getItem("textSize")) || 16),
    _useState6 = _slicedToArray(_useState5, 2),
    textSize = _useState6[0],
    setTextSize = _useState6[1];
  var _useState7 = (0, _react.useState)(parseFloat(localStorage.getItem("lineHeight")) || 1.2),
    _useState8 = _slicedToArray(_useState7, 2),
    lineHeight = _useState8[0],
    setLineHeight = _useState8[1];
  var _useState9 = (0, _react.useState)(parseFloat(localStorage.getItem("textSpacing")) || 0),
    _useState10 = _slicedToArray(_useState9, 2),
    textSpacing = _useState10[0],
    setTextSpacing = _useState10[1];
  var _useState11 = (0, _react.useState)(JSON.parse(localStorage.getItem("readingGuideActive")) || false),
    _useState12 = _slicedToArray(_useState11, 2),
    readingGuideActive = _useState12[0],
    setReadingGuideActive = _useState12[1];
  var _useState13 = (0, _react.useState)(JSON.parse(localStorage.getItem("invertColorsActive")) || false),
    _useState14 = _slicedToArray(_useState13, 2),
    invertColorsActive = _useState14[0],
    setInvertColorsActive = _useState14[1];
  var _useState15 = (0, _react.useState)(JSON.parse(localStorage.getItem("grayHuesActive")) || false),
    _useState16 = _slicedToArray(_useState15, 2),
    grayHuesActive = _useState16[0],
    setGrayHuesActive = _useState16[1];
  var _useState17 = (0, _react.useState)(JSON.parse(localStorage.getItem("underlineLinksActive")) || false),
    _useState18 = _slicedToArray(_useState17, 2),
    underlineLinksActive = _useState18[0],
    setUnderlineLinksActive = _useState18[1];
  var _useState19 = (0, _react.useState)(JSON.parse(localStorage.getItem("suppressAnimationsActive")) || false),
    _useState20 = _slicedToArray(_useState19, 2),
    suppressAnimationsActive = _useState20[0],
    setSuppressAnimationsActive = _useState20[1];
  var _useState21 = (0, _react.useState)(JSON.parse(localStorage.getItem("readableFontActive")) || false),
    _useState22 = _slicedToArray(_useState21, 2),
    readableFontActive = _useState22[0],
    setReadableFontActive = _useState22[1];
  (0, _react.useEffect)(function () {
    document.body.style.letterSpacing = "".concat(textSpacing, "em");
  }, []);
  (0, _react.useEffect)(function () {
    setOptions(function (prevOptions) {
      return mergeOptionsWithInitOptions(prevOptions, initOptions);
    });
  }, [Options]);
  (0, _react.useEffect)(function () {
    localStorage.setItem("textSize", textSize);
    localStorage.setItem("lineHeight", lineHeight);
    localStorage.setItem("textSpacing", textSpacing);
    localStorage.setItem("readingGuideActive", readingGuideActive);
  }, [textSize, lineHeight, textSpacing, readingGuideActive]);
  (0, _react.useEffect)(function () {
    // Update classList based on state
    document.documentElement.classList.toggle("invert-colors", invertColorsActive);
    document.documentElement.classList.toggle("gray-hues", grayHuesActive);
    document.documentElement.classList.toggle("underline-links", underlineLinksActive);
    document.documentElement.classList.toggle("suppress-animations", suppressAnimationsActive);

    // Save settings to localStorage
    localStorage.setItem("invertColorsActive", invertColorsActive);
    localStorage.setItem("grayHuesActive", grayHuesActive);
    localStorage.setItem("underlineLinksActive", underlineLinksActive);
    localStorage.setItem("suppressAnimationsActive", suppressAnimationsActive);
    localStorage.setItem("readableFontActive", readableFontActive);
  }, [invertColorsActive, grayHuesActive, underlineLinksActive, suppressAnimationsActive, readableFontActive]);
  (0, _react.useEffect)(function () {
    if (readingGuideActive) {
      window.addEventListener("mousemove", updateReadingGuidePosition);
    } else {
      window.removeEventListener("mousemove", updateReadingGuidePosition);
    }
    return function () {
      window.removeEventListener("mousemove", updateReadingGuidePosition);
    };
  }, [readingGuideActive]);
  var mergeOptionsWithInitOptions = function mergeOptionsWithInitOptions(opts, initOpts) {
    var updatedOptions = _objectSpread({}, opts);
    Object.keys(initOpts).forEach(function (key) {
      if (initOpts[key] !== null && _typeof(initOpts[key]) === "object" && !Array.isArray(initOpts[key])) {
        updatedOptions[key] = mergeOptionsWithInitOptions(opts[key] || {}, initOpts[key]);
      } else if (opts[key] === null || opts[key] === undefined) {
        updatedOptions[key] = initOpts[key];
      }
    });
    return updatedOptions;
  };
  var toggleMenu = function toggleMenu() {
    setMenuVisible(!menuVisible);
  };
  var increaseTextSize = function increaseTextSize() {
    setTextSize(function (prevSize) {
      var newSize = prevSize + 2;
      document.documentElement.style.fontSize = "".concat(newSize, "px");
      return newSize;
    });
    var elements = document.querySelectorAll(".accessibility-menu, .accessibility-menu *");
    elements.forEach(function (element) {
      element.style.fontSize = "16px";
    });
  };
  var decreaseTextSize = function decreaseTextSize() {
    setTextSize(function (prevSize) {
      var newSize = prevSize - 2;
      document.documentElement.style.fontSize = "".concat(newSize, "px");
      return newSize;
    });
    var elements = document.querySelectorAll(".accessibility-menu, .accessibility-menu *");
    elements.forEach(function (element) {
      element.style.fontSize = "16px";
    });
  };
  var increaseLineHeight = function increaseLineHeight() {
    setLineHeight(function (prevHeight) {
      var newHeight = prevHeight + 0.2;
      var textElements = filterOutAccessibilityOptions(document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button"));
      textElements.forEach(function (element) {
        element.style.lineHeight = "".concat(newHeight);
      });
      return newHeight;
    });
  };
  var decreaseLineHeight = function decreaseLineHeight() {
    setLineHeight(function (prevHeight) {
      var newHeight = prevHeight - 0.2;
      var textElements = filterOutAccessibilityOptions(document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button"));
      textElements.forEach(function (element) {
        element.style.lineHeight = "".concat(newHeight);
      });
      return newHeight;
    });
  };
  var increaseTextSpacing = function increaseTextSpacing() {
    setTextSpacing(function (prevSpacing) {
      var newSpacing = prevSpacing + 0.1;
      var textElements = filterOutAccessibilityOptions(document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button"));
      textElements.forEach(function (element) {
        element.style.letterSpacing = "".concat(newSpacing, "em");
      });
      return newSpacing;
    });
  };
  var decreaseTextSpacing = function decreaseTextSpacing() {
    setTextSpacing(function (prevSpacing) {
      var newSpacing = prevSpacing - 0.1;
      var textElements = filterOutAccessibilityOptions(document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button"));
      textElements.forEach(function (element) {
        element.style.letterSpacing = "".concat(newSpacing, "em");
      });
      return newSpacing;
    });
  };
  var invertColors = function invertColors() {
    setInvertColorsActive(function (prevState) {
      return !prevState;
    });
    document.documentElement.classList.toggle("invert-colors");
  };
  var grayHues = function grayHues() {
    setGrayHuesActive(function (prevState) {
      return !prevState;
    });
    document.documentElement.classList.toggle("gray-hues");
  };
  var underlineLinks = function underlineLinks() {
    setUnderlineLinksActive(function (prevState) {
      return !prevState;
    });
    document.documentElement.classList.toggle("underline-links");
  };
  var suppressAnimations = function suppressAnimations() {
    setSuppressAnimationsActive(function (prevState) {
      return !prevState;
    });
    document.documentElement.classList.toggle("suppress-animations");
  };
  var toggleReadingGuide = function toggleReadingGuide() {
    setReadingGuideActive(function (prevState) {
      return !prevState;
    });
  };
  var updateReadingGuidePosition = function updateReadingGuidePosition(e) {
    var guide = document.getElementById("reading-guide");
    if (guide) {
      guide.style.top = "".concat(e.clientY - 10, "px");
    }
  };
  var readableFont = function readableFont() {
    setReadableFontActive(function (prevState) {
      return !prevState;
    });
    var newFontFamily = "Arial";
    var textElements = Array.from(document.querySelectorAll("*")).filter(function (element) {
      return element.tagName.toLowerCase() !== "i";
    });
    if (readableFontActive) {
      textElements.forEach(function (element) {
        element.style.fontFamily = newFontFamily;
      });
    } else {
      textElements.forEach(function (element) {
        element.style.fontFamily = "";
      });
    }
  };
  var resetToDefault = function resetToDefault() {
    setTextSize(16);
    setLineHeight(1.2);
    setReadingGuideActive(false);
    setTextSpacing(0);
    setInvertColorsActive(false);
    setGrayHuesActive(false);
    setUnderlineLinksActive(false);
    document.documentElement.style.fontSize = "16px";
    document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button").forEach(function (element) {
      element.style.lineHeight = 1.2;
    });
    document.querySelectorAll("h1, h2, h3, h4, h5, h6, p, li, td, th, span, a, label, input, textarea, button").forEach(function (element) {
      element.style.letterSpacing = "0em";
    });
    document.documentElement.classList.remove("invert-colors", "gray-hues", "underline-links", "reading-guide", "suppress-animations");
    localStorage.clear();
  };
  function filterOutAccessibilityOptions(elements) {
    return _toConsumableArray(elements).filter(function (el) {
      var currentElement = el;
      while (currentElement) {
        if (currentElement.classList.contains("accessibility-options")) {
          return false; // Exclude this element
        }

        currentElement = currentElement.parentElement;
      }
      return true;
    });
  }
  var sizeBottom = (options === null || options === void 0 || (_options$style = options.style) === null || _options$style === void 0 || (_options$style = _options$style.position) === null || _options$style === void 0 || (_options$style = _options$style.bottom) === null || _options$style === void 0 ? void 0 : _options$style.size) == null ? 50 : options === null || options === void 0 || (_options$style2 = options.style) === null || _options$style2 === void 0 || (_options$style2 = _options$style2.position) === null || _options$style2 === void 0 || (_options$style2 = _options$style2.bottom) === null || _options$style2 === void 0 ? void 0 : _options$style2.size;
  var side = options.style.position.toRight ? "right" : "left";
  var cssStyle = "\n.accessibility-menu {\n  bottom: ".concat(sizeBottom, "px;\n  ").concat(side, ": ").concat(options.style.position.left.size, "px;\n  position: fixed;\n  z-index: 1000;\n}\n\n.accessibility-options {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    position: fixed;\n    padding-left: 5px;\n    padding-right: 5px;\n    border: #007bff 2px solid;\n    border-radius: 25px;\n    bottom: ").concat(sizeBottom, "px;\n    ").concat(side, ": ").concat(options.style.position.left.size, "px;\n    background-color: #fff;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n    z-index: 999;\n    width: 300px;\n    padding: 0 5px;\n  }\n\n  .accessibility-button {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    font-size: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.rectangle{\n    border-radius: 0px !important;\n}\n\n.dark{\n    background-color: #555555 !important; \n    color: #fff !important;\n}\n\n.exit-reset-buttons{\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 30px;\n}\n\n.button-container button {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    font-size: 14px; \n    padding: 0;  \n    line-height: 1;  \n}\n\n.button-container button i {\n    transition: transform 0.3s ease;\n}\n\n.button-container button:hover i {\n    transform: rotate(180deg);\n}\n\n.button-container button:not(:hover) i {\n    transform: rotate(0deg);\n}\n\n.accessibility-options-title{\n    margin-top: -20px;\n    width: 100%;\n    text-align: center;\n    font-weight: 700;\n    font-size: 24px !important;\n}\n\n\n.accessibility-options.open {\n    display: block;\n}\n\n.exit-reset-buttons .button-container{\n    width: 60px;\n}\n\n.accessibility-options button {\n    margin: 5px;\n    width: calc(100% - 10px);\n    white-space: normal;\n    height: 50px;\n    text-align: center; \n    overflow: hidden; \n    white-space: nowrap; \n    text-overflow: clip;\n    padding: 0 5px;\n    white-space: normal;\n}\n\n.accessibility-options-buttons {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin-bottom: 10px;\n}  \n\n.options-i{\n    margin-right: 10px;\n}\n\n.invert-colors {\n    filter: invert(1);\n    background: black;\n}\n  \n.gray-hues {\n    filter: grayscale(1);\n}\n    \n.underline-links a {\n    text-decoration: underline !important;\n}\n    \n.suppress-animations * {\n    animation: none !important;\n    transition: none !important;\n}\n\n.reading-guide-line {\n    position: fixed;\n    top: 0; /* Adjust this value based on your requirements */\n    left: 0;\n    right: 0;\n    height: 5px;\n    background-color: red;\n    z-index: 10000;\n}\n\n");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "accessibility-menu"
  }, /*#__PURE__*/_react["default"].createElement("link", {
    rel: "stylesheet",
    href: "https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css",
    integrity: "sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T",
    crossOrigin: "anonymous"
  }), /*#__PURE__*/_react["default"].createElement("style", null, cssStyle), /*#__PURE__*/_react["default"].createElement("button", {
    className: "accessibility-button ".concat(options.style.shape == "rectangle" ? "rectangle" : "", " "),
    onClick: toggleMenu
  }, options.style.icon == "wheelchair" ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-wheelchair"
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-universal-access"
  })), menuVisible && /*#__PURE__*/_react["default"].createElement("div", {
    className: "accessibility-options ".concat(menuVisible ? "visible" : "", " ").concat(options.style.mode == "dark" ? "dark" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "exit-reset-buttons"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    title: options.labels.resetTitle != null ? options.labels.resetTitle : "Reset To Default",
    className: "btn btn-success",
    onClick: resetToDefault
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-rotate-right"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    title: options.labels.closeTitle != null ? options.labels.closeTitle : "Exit",
    className: "btn btn-danger",
    onClick: toggleMenu
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-xmark"
  })))), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "accessibility-options-title"
  }, options.labels.menuTitle != null ? options.labels.menuTitle : "Accessibility Menu"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row  accessibility-options-buttons"
  }, (options.modules.increaseText == null || options.modules.increaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: increaseTextSize
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-magnifying-glass-plus fa-lg options-i"
  }), options.labels.increaseText != null ? options.labels.increaseText : "Increase Text Size")), (options.modules.decreaseText == null || options.modules.decreaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: decreaseTextSize
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-magnifying-glass-minus options-i"
  }), options.labels.decreaseText != null ? options.labels.decreaseText : "Decrease Text Size")), (options.modules.increaseText == null || options.modules.increaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: increaseLineHeight
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-text-height options-i"
  }), options.labels.increaseLineHeight != null ? options.labels.increaseLineHeight : "Increase Line Height")), (options.modules.decreaseText == null || options.modules.decreaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: decreaseLineHeight
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-text-height options-i"
  }), options.labels.decreaseLineHeight != null ? options.labels.decreaseLineHeight : "Decrease Line Height")), (options.modules.increaseText == null || options.modules.increaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: increaseTextSpacing
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-expand-arrows-alt fa-lg options-i"
  }), options.labels.increaseTextSpacing != null ? options.labels.increaseTextSpacing : "Increase Text Spacing")), (options.modules.decreaseText == null || options.modules.decreaseText === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: decreaseTextSpacing
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-compress-arrows-alt options-i"
  }), options.labels.decreaseTextSpacing != null ? options.labels.decreaseTextSpacing : "Decrease Text Spacing")), (options.modules.invertColors == null || options.modules.invertColors === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn ".concat(invertColorsActive == true ? "btn-info active" : "btn-primary"),
    onClick: invertColors
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-palette options-i"
  }), options.labels.invertColors != null ? options.labels.invertColors : "Invert Colors")), (options.modules.grayHues == null || options.modules.grayHues === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn ".concat(grayHuesActive == true ? "btn-info active" : "btn-primary"),
    onClick: grayHues
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-circle-half-stroke options-i"
  }), options.labels.grayHues != null ? options.labels.grayHues : "Gray Hues")), (options.modules.underlineLinks == null || options.modules.underlineLinks === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn ".concat(underlineLinksActive == true ? "btn-info active" : "btn-primary"),
    onClick: underlineLinks
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-underline options-i"
  }), options.labels.underlineLinks != null ? options.labels.underlineLinks : "Underline Links")), (options.modules.readingGuide == null || options.modules.readingGuide === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn ".concat(readingGuideActive == true ? "btn-info active" : "btn-primary"),
    onClick: toggleReadingGuide
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-grip-lines options-i"
  }), options.labels.readingGuide != null ? options.labels.readingGuide : "Reading Guide")), (options.modules.disableAnimations == null || options.modules.disableAnimations === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: suppressAnimations
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-pause options-i"
  }), options.labels.disableAnimations != null ? options.labels.disableAnimations : "Suppress Animations")), (options.modules.readableFont == null || options.modules.readableFont === true) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn ".concat(readableFontActive ? "btn-info active" : "btn-primary"),
    onClick: readableFont
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa-solid fa-font options-i"
  }), options.labels.readableFont != null ? options.labels.readableFont : "Readable Font")), readingGuideActive && /*#__PURE__*/_react["default"].createElement("div", {
    id: "reading-guide",
    className: "reading-guide-line"
  }))), /*#__PURE__*/_react["default"].createElement("script", {
    src: "https://kit.fontawesome.com/199ad8a260.js",
    crossOrigin: "anonymous"
  }), /*#__PURE__*/_react["default"].createElement("script", {
    src: "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
  }), /*#__PURE__*/_react["default"].createElement("script", {
    src: "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.16.0/umd/popper.min.js"
  }), /*#__PURE__*/_react["default"].createElement("script", {
    src: "https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"
  }));
};
var _default = exports["default"] = Accessibility;